import React from "react";

import { Reviews } from "@mui/icons-material";
import { useStyles } from "Styles/styles-assortsmart";

const ReviewCell = (props) => {
  const classes = useStyles();

  return (
    <div
      onClick={() => {
        props.onReviewClick(props);
      }}
      title="Review"
    >
      <Reviews className={classes.reviewIcon} />
    </div>
  );
};

export default ReviewCell;
